import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGavel } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import "./vote-item.css";
function VoteItem(props) {
	return (
		<>
			<div className="vote-item mb-3 mb-md-4">
				<Link to="/proposal-detail" className="d-block position-relative">
					<h2 className="mb-3">{props.title}</h2>
					<span className="ending-date-time d-block mb-2">Ends <time className="ending-date" dateTime="">{props.date} {props.time}</time></span>
					<ul className="tags-list list-unstyled mb-0 d-flex">
						{props.core ?
							<li className="me-2 mb-2">
								<span className="d-inline-block align-top px-3 py-1">
									<FontAwesomeIcon icon={faCheckCircle} className="me-3"/>
									Core
								</span>
							</li>
						:
							''
						}
						{props.community ?
							<li className="me-2 mb-2">
								<span className="d-inline-block align-top px-3 py-1">
									<FontAwesomeIcon icon={faUsers} className="me-3"/>
									Community
								</span>
							</li>
						:
							''
						}
						{props.voteNow ?
							<li className="me-2 mb-2">
								<span className="d-inline-block align-top px-3 py-1">
									<FontAwesomeIcon icon={faGavel} className="me-3"/>
									Vote Now
								</span>
							</li>
						:
							''
						}
						{props.closed ?
							<li className="me-2 mb-2 closed">
								<span className="d-inline-block align-top px-3 py-1">
									<FontAwesomeIcon icon={faBan} className="me-3"/>
									Closed
								</span>
							</li>
						:
							''
						}
					</ul>
					<span className="right-arrow">
						<FontAwesomeIcon icon={faArrowRight} />
					</span>
				</Link>
			</div>
		</> 
	);
}

export default VoteItem;